module.exports = __webpack_public_path__ + "static/media/lungern-plazaA-03.1377e6d1.webp";